<div class="receipt">
    <p class="rct-p">未歸還時的發票開立方式</p>
    <div class="rct-filter">
        <select name="name" class="rct-slt" style="color: #313131">
            <option value="請選擇">uniopen會員載具</option>
        </select>
    </div>
</div>